<script lang="ts" setup>
import {
  ApiValidationError,
  type RawApiValidationError,
} from '#Common/models/Error'

// Переиспользуемый компонент для отображения ошибок API
const props = defineProps<{
  error?: RawApiValidationError
}>()

const messages = computed(() => {
  if (!props.error?.errors) return []

  return ApiValidationError.getMessages(props.error)
})
</script>

<template>
  <UAlert v-if="error" color="error" :title="error?.detail || error.title">
    <template v-if="messages?.length" #description>
      <ul class="list-disc pl-4">
        <li v-for="(message, index) in messages" :key="index">
          {{ message }}
        </li>
      </ul>
    </template>
  </UAlert>
</template>
